export const cus_rib_user = "cus-rib-user";

export const cus_rib_guardian = "cus-rib-guardian";

export const cus_rib_loggedInClinic = "cus-rib-loggedInClinic";

export const cus_rib_loggedInRole = "cus-rib-loggedInRole";

export const recordActivityActions = {
  addPrescriptionList: "addPrescriptionList",
  addActivitiesList: "addActivitiesList",
  addPatientsList: "addPatientsList",
  addAdminList: "addAdminList",
  addPractitionersList: "addPractitionersList",
};
